import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { ParkingType } from '@parkupp/core'
import { ToastrService } from 'ngx-toastr'
import { AuthenticationService } from '../../../services/authentication.service'

@Component({
    selector: 'app-merchant-parking-type',
    templateUrl: './merchant-parking-type.component.html',
    styleUrls: ['./merchant-parking-type.component.scss'],
})
export class MerchantParkingTypeComponent implements OnInit {
    @Output() parkingType = new EventEmitter<ParkingType>()
    parkingTypes = ParkingType

    constructor(private toastrService: ToastrService, public authService: AuthenticationService) {}

    ngOnInit(): void {}

    selectParkingType(parkingType: ParkingType) {
        if (parkingType == ParkingType.STANDARD || ParkingType.PARKING_COLLECTOR || ParkingType.PARKING_EVENTS) {
            this.parkingType.emit(parkingType)
        } else {
            this.toastrService.error('That parking is not available yet. Please choose classic parking or contact us.', 'Not Available')
        }
    }
}
